/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        tabs: {
            paddingTop: {
                value: "4px",
                type: "dimension",
            },
            paddingBottom: {
                value: "4px",
                type: "dimension",
            },
            paddingLeft: {
                value: "4px",
                type: "dimension",
            },
            paddingRight: {
                value: "4px",
                type: "dimension",
            },
            active: {
                default: {
                    backgroundColor: {
                        value: "#d3222a",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#ee312e",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                focus: {
                    backgroundColor: {
                        value: "#af292e",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                disabled: {
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    color: {
                        value: "#a0a2a5",
                        type: "color",
                    },
                },
            },
            inactive: {
                default: {
                    backgroundColor: {
                        value: "#f3f3f3",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#f3f3f3",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                focus: {
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                disabled: {
                    backgroundColor: {
                        value: "#ffffff",
                        type: "color",
                    },
                    color: {
                        value: "#a0a2a5",
                        type: "color",
                    },
                },
            },
            sizes: {
                medium: {
                    container: {
                        gap: {
                            value: "8px",
                            type: "dimension",
                        },
                    },
                    button: {
                        height: {
                            value: "32px",
                            type: "dimension",
                        },
                        borderRadius: {
                            value: "10px",
                            type: "dimension",
                        },
                        paddingTop: {
                            value: "6px",
                            type: "dimension",
                        },
                        paddingBottom: {
                            value: "6px",
                            type: "dimension",
                        },
                        paddingLeft: {
                            value: "16px",
                            type: "dimension",
                        },
                        paddingRight: {
                            value: "16px",
                            type: "dimension",
                        },
                        gap: {
                            value: "12px",
                            type: "dimension",
                        },
                        fontSize: {
                            value: "0.875rem",
                            type: "dimension",
                        },
                        fontWeight: {
                            value: 600,
                            type: "number",
                        },
                        lineHeight: {
                            value: "1.25rem",
                            type: "dimension",
                        },
                        letterSpacing: {
                            value: "0.2px",
                            type: "dimension",
                        },
                    },
                },
                large: {
                    container: {
                        gap: {
                            value: "12px",
                            type: "dimension",
                        },
                    },
                    button: {
                        height: {
                            value: "40px",
                            type: "dimension",
                        },
                        borderRadius: {
                            value: "12px",
                            type: "dimension",
                        },
                        paddingLeft: {
                            value: "20px",
                            type: "dimension",
                        },
                        paddingRight: {
                            value: "20px",
                            type: "dimension",
                        },
                        gap: {
                            value: "12px",
                            type: "dimension",
                        },
                        fontSize: {
                            value: "1rem",
                            type: "dimension",
                        },
                        fontWeight: {
                            value: 600,
                            type: "number",
                        },
                        lineHeight: {
                            value: "1.5rem",
                            type: "dimension",
                        },
                        letterSpacing: {
                            value: "0.2px",
                            type: "dimension",
                        },
                    },
                },
            },
            icon: {
                width: {
                    value: "20px",
                    type: "dimension",
                },
                height: {
                    value: "20px",
                    type: "dimension",
                },
            },
            badge: {
                height: {
                    value: "24px",
                    type: "dimension",
                },
                paddingTop: {
                    value: "2px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "2px",
                    type: "dimension",
                },
                paddingLeft: {
                    value: "8px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "8px",
                    type: "dimension",
                },
                borderRadius: {
                    value: "9999px",
                    type: "dimension",
                },
                fontSize: {
                    value: "0.875rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "number",
                },
                active: {
                    backgroundColor: {
                        value: "#ffffff",
                        type: "color",
                    },
                    color: {
                        value: "#d3222a",
                        type: "color",
                    },
                },
                inactive: {
                    backgroundColor: {
                        value: "#d3222a",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                counter: {
                    borderRadius: {
                        value: "2px",
                        type: "dimension",
                    },
                    paddingTop: {
                        value: "2px",
                        type: "dimension",
                    },
                    paddingBottom: {
                        value: "2px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "8px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "8px",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
